import pathNamesWithNoIndex from './pathNamesWithNoIndex'

export const getNoIndexValueFromPath = (url: string | undefined) => {
	if (url?.startsWith('/dm/')) return true

	if (url) return pathNamesWithNoIndex.includes(url)

	return false
}
